export const educationData = [
   {
        id: 1,
        institution: 'National Institute of science and technology',
        course: 'Master of Computer Application (MCA)',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'Berhampur University',
        course: 'Bachelor of science (Computer Science)',
        Honors:'Computer Science',
        startYear: '2016',
        endYear: '2019'
    },
    
]